import Config from "../../Config";
import AxiosRequest from "./AxiosRequest";
import ServerRequest from "./ServerRequest";

export default class Server {

    public static newRequest(): ServerRequest {
        return new AxiosRequest(Config.API_ROOT);
    }
}
